import { render, staticRenderFns } from "./ProfileDropDown.vue?vue&type=template&id=45e672ea&"
import script from "./ProfileDropDown.vue?vue&type=script&lang=js&"
export * from "./ProfileDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports